export default (url: string, data?: {}, options?: RequestInit) => {
    const requestOptions: RequestInit = {
        ...{
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=UTF-8"
            },
            credentials: "include",
            mode: "cors"
        },
        ...options
    };

    if (data) {
        requestOptions.body = JSON.stringify(data);
    }

    return fetch(url, requestOptions)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            return Promise.reject({
                status: response.status,
                statusText: response.statusText
            });
        })
        .catch((reason) => {
            throw reason;
        });
}



// WEBPACK FOOTER //
// ./@modules/utils/create-request.ts